import ShadowRecommend from './shadow';
import { Box } from '@mui/material';

export default function Recommend() {
  return (
    <>
      <Box>
        <ShadowRecommend />
      </Box>
    </>
  );
}
